import {parserMainClass} from "./mainParser";
import {Observable} from "rxjs";

export class imageParseClass extends parserMainClass {

  private allowedTypes = ['jpg','jpeg','png'];

  constructor(file) {
    super(file);
  }

  public getData() {
    return new Observable((observer)=>{
      if (!this.isAllowedType()){
        observer.error('Wrong file type added! File type must be '+this.allowedTypes.join(','));
        return;
      }
      var reader = new FileReader();
      reader.onload = function(){
        observer.next(reader.result);
      };

      reader.onerror = ()=>{
        observer.error('Error during file reading...');
      };
      let img2 = new Image();
      let url = URL.createObjectURL(this.file);
      img2.onload = ()=>{
        // observer.next(img2.src)
      };
      img2.src = url;

      reader.readAsDataURL(this.file);
    });
  }

  protected isAllowedType(){
    return this.allowedTypes.includes(this.type.toLowerCase());
  }
}
